import { Notification } from '@skalpel/components';
import React from 'react';
import { toast } from 'react-hot-toast';
import type { Toast } from 'react-hot-toast';

import type { ToastInput } from './types';

const TOAST_DURATION_MS = 5000;
const LOADING_TOAST_ID = 'loading';
const LOADING_DELAY_MS = 400;
const IMMEDIATE_REMOVE_DELAY_MS = 1;

let runningRequests = 0;
let loadingTimeout: number | null = null;

const renderToast =
	({ feel, title }: ToastInput, dismissible: boolean) =>
	(currentToast: Toast) => (
		<div className="w-max max-w-[min(600px,calc(100vw-32px))]">
			<Notification
				feel={feel}
				fullWidth
				isElevated
				title={title}
				{...(dismissible && {
					onDismiss: () => {
						toast.dismiss(currentToast.id);
					},
				})}
			/>
		</div>
	);

export function renderNotification(input: ToastInput) {
	toast.custom(renderToast(input, true), { duration: TOAST_DURATION_MS, removeDelay: IMMEDIATE_REMOVE_DELAY_MS });
}

export function startLoading() {
	runningRequests += 1;

	loadingTimeout ??= window.setTimeout(() => {
		toast.custom(renderToast({ feel: 'info', title: 'Načítáme…' }, false), {
			duration: Infinity,
			id: LOADING_TOAST_ID,
			removeDelay: IMMEDIATE_REMOVE_DELAY_MS,
		});
	}, LOADING_DELAY_MS);
}

export function stopLoading() {
	runningRequests = Math.max(0, runningRequests - 1);

	if (runningRequests > 0 || loadingTimeout === null) {
		return;
	}

	clearTimeout(loadingTimeout);
	loadingTimeout = null;
	toast.dismiss(LOADING_TOAST_ID);
}
